import { useState } from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { ConfirmarAccion } from "@/components/migracion/ConfirmarAccion";
import { api, apiError } from "@/lib/api";
import { consultasTxt } from "@/lib/migracion";

export function DeclaracionConfirmar({ lote, onLanzado }) {
  const [acepto, setAcepto] = useState(false);
  const [preguntar, setPreguntar] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const c = lote.conteos || {};
  const utiles = (c.pendientes_nuevo || 0) + (c.pendientes_vincular || 0) + (c.pendientes_credito || 0)
    + (c.pendientes_correccion || 0);
  const bloqueo = lote.mensaje_bloqueo;
  const deshabilitado = !utiles || !acepto || !!bloqueo || enviando;

  const confirmar = async () => {
    setEnviando(true);
    try {
      await api.post(`/migracion-cartera/lotes/${lote.id}/confirmar`, { acepto_declaracion: true });
      toast.success("Migración en proceso. Puedes seguir usando la plataforma.");
      onLanzado();
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <section className="rounded-lg border border-slate-200 bg-white p-5" data-testid="migracion-paso-declaracion">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Paso 3</p>
      <h2 className="mt-1 flex items-center gap-2 text-base font-semibold text-slate-900">
        <ShieldCheck className="h-4 w-4 text-primary" /> Declaración de responsabilidad
      </h2>
      <p className="mt-2 rounded-md border border-slate-200 bg-slate-50 p-3 text-sm leading-relaxed text-slate-700" data-testid="migracion-declaracion-texto">
        {lote.declaracion_texto}
      </p>
      <label className="mt-3 flex items-center gap-2 text-sm text-slate-800">
        <Checkbox checked={acepto} onCheckedChange={(v) => setAcepto(v === true)} data-testid="migracion-acepto-declaracion" />
        He leído y acepto la declaración
      </label>
      {bloqueo && (
        <p className="mt-3 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="migracion-mensaje-bloqueo">{bloqueo}</p>
      )}
      {!utiles && <p className="mt-3 text-sm text-slate-500" data-testid="migracion-sin-utiles">El archivo no tiene clientes ni créditos válidos para procesar.</p>}
      <Button className="mt-3 gap-2" disabled={deshabilitado} onClick={() => setPreguntar(true)} data-testid="migracion-confirmar">
        {enviando && <Loader2 className="h-4 w-4 animate-spin" />} Confirmar migración
      </Button>
      <ConfirmarAccion abierto={preguntar} onCerrar={() => setPreguntar(false)} titulo="Confirmar migración"
        accion="Confirmar migración" onConfirmar={confirmar} testid="migracion-confirmar-dialogo">
        Se darán de alta <b>{lote.conteos?.pendientes_nuevo || 0}</b> clientes nuevos (consumen
        {" "}{lote.conteos?.pendientes_nuevo || 0} consultas de tu plan; disponibles: {consultasTxt(lote.consultas_disponibles_ahora)}) y se
        vincularán <b>{lote.conteos?.pendientes_vincular || 0}</b> clientes que ya existen en FELVORA, sin cambiar sus datos.
        {c.pendientes_credito > 0 && (
          <> Después se migrarán <b>{c.pendientes_credito}</b> créditos: cada uno nace autorizado por migración (sin Comité),
          se contrata y se desembolsa con su fecha original y sus cuotas ya pagadas.</>
        )}
        {c.pendientes_correccion > 0 && (
          <> Al final se corregirán <b>{c.pendientes_correccion}</b> créditos ya cargados: conservan número, cliente,
          expediente y pagos reales; la tabla se recalcula desde la fecha original y los pagos reales se reaplican.
          Si una corrección falla, ese crédito queda exactamente como estaba.</>
        )}
        {" "}Las filas con error u omitidas no se procesan. La carga corre aparte en bloques de 20.
      </ConfirmarAccion>
    </section>
  );
}
